import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Box, Button, Container, Paper, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { t: myTranslate } = useTranslation();

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <LockOutlinedIcon color="error" sx={{ fontSize: 48, mb: 2 }} />
          <Typography
            component="h1"
            variant="h5"
            className="notranslate"
            translate="no"
            gutterBottom
          >
            {myTranslate("auth.accessDenied")}
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            className="notranslate"
            translate="no"
            align="center"
            sx={{ mb: 3 }}
          >
            {myTranslate("auth.noPermission")}
          </Typography>
          <Button
            variant="contained"
            className="notranslate"
            translate="no"
            onClick={() => navigate("/")}
            sx={{ mt: 2 }}
          >
            {myTranslate("auth.backToMain")}
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default Unauthorized;
